
import React from 'react';
import { CheckCircle } from 'lucide-react';

const UlosotonValttaminenSection: React.FC = () => {
  return (
    <>
      <h2>Miten välttää ulosotto?</h2>
      <p>
        Paras tapa välttää ulosotto on reagoida maksuvaikeuksiin mahdollisimman varhaisessa vaiheessa. 
        Tässä muutamia konkreettisia toimenpiteitä:
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-6">
        <div className="bg-green-50 p-5 rounded-lg border border-green-200">
          <h3 className="text-lg font-semibold mb-3 flex items-center"><CheckCircle size={20} className="mr-2 text-green-600" /> Ota yhteyttä velkojaan</h3>
          <p>
            Neuvottele uudesta maksuaikataulusta heti kun huomaat, että et pysty maksamaan laskua eräpäivään mennessä. 
            Useimmat velkojat suostuvat joustamaan, kun otat asian puheeksi ajoissa.
          </p>
        </div>

        <div className="bg-green-50 p-5 rounded-lg border border-green-200">
          <h3 className="text-lg font-semibold mb-3 flex items-center"><CheckCircle size={20} className="mr-2 text-green-600" /> Hae maksunlykkäystä</h3>
          <p>
            Monilla yrityksillä ja viranomaisilla on omat prosessinsa maksunlykkäyksen hakemiseen. 
            Esimerkiksi verottaja voi myöntää maksuaikaa veroille.
          </p>
        </div>

        <div className="bg-green-50 p-5 rounded-lg border border-green-200">
          <h3 className="text-lg font-semibold mb-3 flex items-center"><CheckCircle size={20} className="mr-2 text-green-600" /> Selvitä yhdistelylainan mahdollisuus</h3>
          <p>
            Jos sinulla on useita lainoja, harkitse niiden yhdistämistä yhdeksi edullisemmaksi lainaksi. 
            Tämä voi pienentää kuukausittaisia maksuja.
          </p>
        </div>

        <div className="bg-green-50 p-5 rounded-lg border border-green-200">
          <h3 className="text-lg font-semibold mb-3 flex items-center"><CheckCircle size={20} className="mr-2 text-green-600" /> Hae talous- ja velkaneuvontaa</h3>
          <p>
            Kunnallinen talous- ja velkaneuvonta auttaa maksuvaikeuksissa olevia täysin maksutta. 
            He voivat auttaa velkojen järjestelyssä ja budjetin laatimisessa.
          </p>
        </div>
      </div>
    </>
  );
};

export default UlosotonValttaminenSection;
